import { render } from "./cfParametersComponent.vue?vue&type=template&id=b8deb86e&scoped=true"
import script from "./cfParametersComponent.vue?vue&type=script&lang=js"
export * from "./cfParametersComponent.vue?vue&type=script&lang=js"

import "./cfParametersComponent.vue?vue&type=style&index=0&id=b8deb86e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8deb86e"]])

export default __exports__